import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Two-state language toggle. Click cycles EN ↔ AR. Persists via i18next's
 * languageDetector (localStorage key `app_language`). Updates document.dir
 * + html lang as a side effect through src/i18n.js's languageChanged hook.
 */
export default function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  const next    = current === 'ar' ? 'en' : 'ar';

  const switchTo = () => i18n.changeLanguage(next);

  return (
    <button
      type="button"
      onClick={switchTo}
      title={current === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
      className={`lang-switcher px-2 py-1 mx-2 rounded border-0 bg-transparent text-light fw-semibold ${className}`}
      style={{ fontSize: '0.9rem' }}
    >
      <span className={current === 'en' ? 'opacity-100' : 'opacity-50'}>EN</span>
      <span className="mx-1 opacity-50">|</span>
      <span className={current === 'ar' ? 'opacity-100' : 'opacity-50'}>عربي</span>
    </button>
  );
}
